import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Testimonials() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-257" data-mp="3mgslk8tzzbay">
      <div className="mx-auto max-w-3xl" data-id="element-258" data-mp="3mfhgm5otfxi9">
        <p className="flex items-center justify-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-spark-500" data-id="element-259" data-mp="3r78ylrtwouws">
          <StarIcon className="h-3.5 w-3.5 fill-spark-500" aria-hidden="true" data-id="element-260" data-mp="fxenz44vs9" />
          Ce que disent les soudeurs
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-261" data-mp="40zx9zb2mdi3">
          Des résultats concrets dans l’atelier
        </h2>

        <div className="mt-8 space-y-4" data-id="element-262" data-mp="e0gya3fdo37q">
          {testimonials.map(t => <figure key={t.name} className="rounded-2xl border border-white/10 bg-ink-800/70 p-5" data-id="element-263" data-mp="2auamzn137o97">
              <div className="flex items-center gap-3" data-id="element-264" data-mp="2fug9ypwewmky">
                <img src={t.photo} alt={`Portrait de ${t.name}`} className="h-14 w-14 shrink-0 rounded-full border-2 border-arc-500/50 object-cover" data-id="element-265" data-mp="1slkpb9ggb2ge" />
                <figcaption className="min-w-0" data-id="element-266" data-mp="1iv984l7rawrk">
                  <p className="text-base font-extrabold leading-tight text-white" data-id="element-267" data-mp="1ete7zk1kapfd">
                    {t.name}
                  </p>
                  <p className="text-xs text-white/55" data-id="element-268" data-mp="2bi3ujno4w67o">{t.role}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 étoiles sur 5" data-id="element-269" data-mp="26jsjxaq0lroe">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-spark-500 text-spark-500" aria-hidden="true" data-id="element-270" data-mp="22gvvv4hph3d2" data-mpi={i} />)}
                  </div>
                </figcaption>
              </div>
              <blockquote className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-271" data-mp="m35pfr346309">
                « {t.quote} »
              </blockquote>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-272" data-mp="sk77p33qrmxf">
          <CtaBlock label="Je veux les mêmes résultats" data-id="element-273" data-mp="sicw4fed1760" />
        </div>
      </div>
    </section>;
}